import { Activity, BookOpen, ClockAlert, HardDrive, Inbox, Siren, TriangleAlert } from 'lucide-react';
import { Card, CardBody } from '@/shared/components/ui/Card';
import type { ServiceDeskSummary } from '../types';
import { activeTicketCount } from '../viewModel';

export function ServiceDeskSummaryCards({ summary }: { summary?: ServiceDeskSummary | null }) {
  const cards = [
    { label: 'Active tickets', value: activeTicketCount(summary), icon: Inbox, tone: 'text-primary bg-primary/10' },
    { label: 'SLA warning', value: summary?.sla.warning ?? 0, icon: ClockAlert, tone: 'text-warning-text bg-warning/10' },
    { label: 'SLA breached', value: summary?.sla.breached ?? 0, icon: TriangleAlert, tone: 'text-danger-text bg-danger/10' },
    { label: 'Critical queue', value: summary?.priorityCounts.critical ?? 0, icon: Siren, tone: 'text-danger-text bg-danger/10' },
    { label: 'Assets', value: summary?.assetCount ?? 0, icon: HardDrive, tone: 'text-info-text bg-info/10' },
    { label: 'Open incidents', value: summary?.openIncidents ?? 0, icon: Activity, tone: 'text-warning-text bg-warning/10' },
    { label: 'Knowledge', value: summary?.knowledgeCount ?? 0, icon: BookOpen, tone: 'text-success-text bg-success/10' },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4 xl:grid-cols-7" aria-label="Service Desk summary">
      {cards.map(card => (
        <Card key={card.label}>
          <CardBody className="flex items-center gap-3 p-4">
            <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${card.tone}`}>
              <card.icon className="h-4 w-4" aria-hidden />
            </span>
            <div className="min-w-0">
              <p className="text-display-sm font-semibold text-on-surface">{card.value}</p>
              <p className="truncate text-body-sm text-on-surface-variant">{card.label}</p>
            </div>
          </CardBody>
        </Card>
      ))}
    </div>
  );
}
